import { isEmbedCapabilities } from "./embed-protocol";

/** 互換性情報の取得に許す待ち時間（ms）。 */
const FETCH_TIMEOUT_MS = 5000;
/** 互換性情報 JSON の受理上限（バイト相当の文字数）。 */
const BODY_LENGTH_MAX = 16384;

/**
 * Feedback 側がこのクライアント向けの埋め込みを提供しているかを照合する。
 *
 * 照合に成功したときだけ iframe を作る。Feedback 側の配備前（404）や
 * `enabled: false` でも安全に配備できるよう、失敗はすべて `false` へ畳む。
 * 資格情報は送らず（`credentials: "omit"`）、リダイレクトも追わない。
 */
export async function hasCompatibleFeedback(
  origin: string,
  clientId: string,
  hostOrigin: string,
  signal: AbortSignal,
  fetchImpl: typeof fetch = fetch
): Promise<boolean> {
  try {
    const response = await fetchImpl(`${origin}/embed/${clientId}/capabilities.json`, {
      credentials: "omit",
      redirect: "error",
      cache: "no-store",
      signal: AbortSignal.any([signal, AbortSignal.timeout(FETCH_TIMEOUT_MS)]),
    });
    if (
      !response.ok ||
      !response.headers.get("content-type")?.toLowerCase().includes("application/json")
    ) {
      return false;
    }
    const text = await response.text();
    if (text.length > BODY_LENGTH_MAX) return false;
    const value: unknown = JSON.parse(text);
    return (
      isEmbedCapabilities(value) &&
      value.enabled &&
      value.clientId === clientId &&
      value.hostOrigin === hostOrigin
    );
  } catch {
    // 取得不可・形式不正・タイムアウトはいずれも「互換性を確認できない」として扱う。
    return false;
  }
}
